<template>
    <b-modal title="Redeem Giftcard" :id="`redeem-giftcards`" hide-footer>
        <b-overlay :show="isLoading">
            <form @submit.prevent="redeem">
                <b-row align-v="end">
                    <b-col>
                        <b-form-group label="Experienced at">
                            <b-form-datepicker locale="nb-NO" :start-weekday="1" v-model="experienced_date" :min="new Date()" />
                        </b-form-group>
                    </b-col>
                  <b-col>
                    <b-form-group label="Time">
                      <b-form-timepicker locale="nb-NO" v-model="experienced_time" now-button reset-button />
                    </b-form-group>
                  </b-col>
                    <b-col cols="auto">
                        <b-button variant="primary" style="margin-bottom: 1rem" type="submit">
                            Redeem
                        </b-button>
                    </b-col>
                </b-row>
            </form>
        </b-overlay>
    </b-modal>
</template>

<script>
import { giftcard } from '@/api'
import { formatDate, formatMoney } from '../../page-helpers'

export default {
    name: 'RedeemGiftcardModal',

    props: {
        orderDetails: Array,
    },

    data() {
        return {
            isLoading: false,
            experienced_date: null,
            experienced_time: null,
        }
    },

    computed: {
        experienced_at() {
            if (!this.experienced_date) {
              return null
            }

            return `${this.experienced_date} ${this.experienced_time || '00:00:00'}`
        },
    },

    methods: {
        formatDate,
        formatMoney,

        async redeemGiftcard(id) {
            this.isLoading = true
            await this.$store.dispatch('auth/refreshToken');
            await giftcard.redeem(id, this.experienced_at)
        },

        async redeem() {
            this.isLoading = true
            for (const od of this.orderDetails) {
                try {
                    await this.redeemGiftcard(od.giftcard.id)
                    this.$emit('triggerUpdate')
                    this.$emit('triggerLoadOrderDetails')
                    this.$bvToast.toast(`Giftcard with code ${od.giftcard.code} was succesfully redeemed.`, {
                        title: 'Giftcard Redeemed',
                        variant: 'primary',
                    })
                } catch (error) {
                    this.$bvToast.toast(`Giftcard with code ${od.giftcard.code} could not be redeemed`, {
                        title: 'Invalid Giftcard Redeem',
                        variant: 'danger',
                    })
                }
            }
            this.isLoading = false
            this.$bvModal.hide('redeem-giftcards')
            this.experienced_date = null
            this.experienced_time = null
        },
    },
}
</script>
